'use client';

import { cn } from '@/lib/utils';
import { Media } from '@/payload-types';
import Image from 'next/image';

interface ImageFullWidthProps {
    afbeelding: string | Media;
}

export default function ImageFullWidth({ afbeelding }: ImageFullWidthProps) {
    return (
        <div className="w-full overflow-hidden">
            {typeof afbeelding !== 'string' &&
            afbeelding.mimeType &&
            afbeelding.mimeType.startsWith('video/') ? (
                <video
                    src={'/api/video?url=' + afbeelding.filename}
                    className="h-auto w-full object-cover"
                    loop
                    muted
                    controls
                    autoPlay
                />
            ) : (
                <Image
                    className={cn(
                        typeof afbeelding === 'string'
                            ? 'bg-accent w-fill h-full w-full object-cover'
                            : 'bg-accent w-fill h-full w-full object-cover',
                    )}
                    src={
                        typeof afbeelding === 'string'
                            ? '/placeholder.svg'
                            : afbeelding.url || '/placeholder.svg'
                    }
                    alt={typeof afbeelding === 'string' ? '' : afbeelding.alt}
                    width={
                        typeof afbeelding === 'string'
                            ? 1077
                            : afbeelding.width || 1077
                    }
                    height={
                        typeof afbeelding === 'string'
                            ? 1077
                            : afbeelding.height || 1077
                    }
                />
            )}
        </div>
    );
}
